import { useAppSelector as useSelector } from 'dux/app/hooks';

import { MetaData } from 'Components/MetaData';
import { ProductCollection } from '../Components/ProductCollection';

import { skincareCollection } from 'assets/content/productPages/skincareCollection';

import * as productsSelectors from 'dux/products/selectors';

const SkincareProductCollection = () => {
  const productsBlockContent = useSelector(productsSelectors.getSkincareProductsBlockContent);
  return (
    <>
      <MetaData
        description="Discover Prose custom skin products, freshly bottled, made-to-order, and personalized to 85+ factors from your in-depth skin consultation. Formulated with a unique blend of naturally powerful ingredients. Refresh your skin routine."
        title="Custom Skin Products – Prose | Skincare"
      />
      <ProductCollection
        content={skincareCollection}
        dataFrom="product-grid"
        productsBlockContent={productsBlockContent}
      />
    </>
  );
};

export default SkincareProductCollection;
